module.exports = __webpack_public_path__ + "img/answer-delete-default.8fae29f8.svg";